import { useTranslation } from 'react-i18next'

import { lightPalette } from '../palette'
import { Eyebrow } from './Eyebrow'

export function ChannelsSection() {
  const { t } = useTranslation()

  const cards = [
    {
      title: t('landing.channels.card1Title'),
      desc: t('landing.channels.card1Desc'),
      status: t('landing.channels.card1Status'),
      available: true,
    },
    {
      title: t('landing.channels.card2Title'),
      desc: t('landing.channels.card2Desc'),
      status: t('landing.channels.card2Status'),
      available: true,
    },
    {
      title: t('landing.channels.card3Title'),
      desc: t('landing.channels.card3Desc'),
      status: t('landing.channels.card3Status'),
      available: false,
    },
    {
      title: t('landing.channels.card4Title'),
      desc: t('landing.channels.card4Desc'),
      status: t('landing.channels.card4Status'),
      available: false,
    },
  ]

  return (
    <section style={{ maxWidth: 1200, margin: '0 auto', padding: '88px 24px' }}>
      <div
        data-reveal=""
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          maxWidth: 600,
          marginBottom: 36,
        }}
      >
        <Eyebrow>{t('landing.channels.eyebrow')}</Eyebrow>
        <h2
          style={{
            margin: 0,
            fontSize: 'clamp(26px,3vw,38px)',
            lineHeight: 1.12,
            fontWeight: 600,
            letterSpacing: '-0.035em',
          }}
        >
          {t('landing.channels.title')}
        </h2>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(230px,1fr))',
          gap: 16,
        }}
      >
        {cards.map((card) => (
          <div
            key={card.title}
            data-reveal=""
            style={{
              border: `1px solid ${card.available ? lightPalette.borderDefault : lightPalette.borderSoft}`,
              borderRadius: 14,
              background: card.available ? lightPalette.surface : lightPalette.surfaceSubtle,
              padding: 22,
              display: 'flex',
              flexDirection: 'column',
              gap: 9,
            }}
          >
            <span
              style={{
                fontSize: 15.5,
                fontWeight: 700,
                color: card.available ? undefined : lightPalette.textBody,
              }}
            >
              {card.title}
            </span>
            <span
              style={{
                fontSize: 13.5,
                color: card.available ? lightPalette.textBody : lightPalette.textFaint,
                lineHeight: 1.55,
              }}
            >
              {card.desc}
            </span>
            <span
              style={{
                alignSelf: 'flex-start',
                marginTop: 4,
                fontSize: 11,
                fontWeight: 700,
                padding: '3px 9px',
                borderRadius: 6,
                background: card.available ? lightPalette.successBg : 'transparent',
                border: card.available ? undefined : `1px solid ${lightPalette.borderStrong}`,
                color: card.available ? lightPalette.successFg : lightPalette.textFaint,
              }}
            >
              {card.status}
            </span>
          </div>
        ))}
      </div>
    </section>
  )
}
